<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          โครงการหลักที่ยื่นเสนอ สป.อว
        </div>
        <div class="d-flex align-center font-type-bold txt-head black--text">
          <Iconify
              icon="ci:list-checklist"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          โครงการหลักที่ยื่นเสนอ สป.อว
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 250px">
            <div class="min-width-max">สถานะ</div>
            <SelectBox
                placeholder="สถานะ"
                hide-details
                :items="statusMaster"
                @onChange="searchData.status = $event; getFormAList()"
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
                @onChange="searchData.keyword = $event"
                @onEnter="getFormAList()"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end">
<!--          <Button-->
<!--              @onClick="createProject"-->
<!--          >-->
<!--            สร้างโครงการ-->
<!--          </Button>-->
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <MainProjectOfferItem
            v-for="(item, i) in formAList"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
        ></MainProjectOfferItem>
      </div>

      <v-pagination
          class="mt-6"
          v-model="paginate.current_page"
          :length="paginate.last_page"
          color="#DE7033"
          @input="getFormAList"
      ></v-pagination>

    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import Button from "../../components/input/Button"
import SelectBox from "../../components/input/SelectBox"
import MainProjectOfferItem from "../../components/MainProjectOfferItem"

export default {
  name: "MainProjectOffer",
  components: {
    TextField,
    SelectBox,
    MainProjectOfferItem,
    Button
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '8%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'ปี งปม.',
          width: '8%'
        },
        {
          name: 'ชื่อโครงการหลัก',
          width: '34%'
        },
        {
          name: 'ผู้นำเข้าข้อมูล',
          width: '10%'
        },
        {
          name: 'วัน-เวลาที่สร้าง',
          width: '13%'
        },
        {
          name: 'ภูมิภาค',
          width: '8%'
        },
        {
          name: 'สถานะ',
          width: '8%'
        },
        {
          name: '',
          width: '5%'
        }
      ],
      formAList: [],
      searchData: {
        status: null,
        keyword: null
      },
      statusMaster: [
          'Draft',
          'Submitted1',
          'Inception',
          'Submitted2',
          'Approved',
          'Completed',
      ],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    }
  },
  created () {
    this.getFormAList()
  },
  methods: {
    createProject () {
      this.$router.push({ name: 'MainProjectForm' })
    },
    async getFormAList (page) {
      let payload = {
        page: page,
        status: this.searchData.status ?? this.statusMaster.join(','),
        keyword: this.searchData.keyword
      };

      let res
      res = await this.$apiFire('AForm/getFormAList', payload)
      console.log(res)
      console.log(res.data)
      this.formAList = res.data.map((item, index) => {
        return {
          ...item,
          no: (res.current_page - 1) * res.per_page + index + 1
        }
      });
      this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
    }
  }
}
</script>

<style scoped>
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>